import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import AssetInventory from "./AssetInventory";
import Login from "./Login";
import { auth } from "./api";

/* ==========================================================================
   Entry point and session gate.

   The server is the authority on whether there is a session — this asks
   GET /api/me on boot rather than trusting anything stored in the browser.
   ========================================================================== */

function Root() {
  const [user, setUser] = useState(null);
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    // Returns null on 401 rather than throwing — not being signed in is an
    // answer, not a failure.
    auth
      .me()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setBooted(true));
  }, []);

  function handleSignedIn(signedInUser) {
    setUser(signedInUser);
    // Drop /login out of the address bar so a refresh does not land back on it.
    if (window.location.pathname === "/login") {
      window.history.replaceState({}, "", "/");
    }
  }

  async function handleSignOut() {
    try {
      await auth.logout();
    } finally {
      setUser(null);
    }
  }

  // Nothing rendered until the session question is answered, so the login page
  // never flashes in front of somebody who is already signed in.
  if (!booted) return null;

  if (!user) return <Login onSignedIn={handleSignedIn} />;

  // The app takes the real session and reads everything else from the API.
  return <AssetInventory user={user} onSignOut={handleSignOut} />;
}

createRoot(document.getElementById("root")).render(<Root />);
